import React from 'react';
import './Contact.css';
import SEO from '../components/seo/SEO';
import ContactForm from '../components/contactForm/ContactForm';

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact | Explorelrt"
        description="Contact Explorelrt using the embedded form for questions, feedback, or support."
      />

      <div className="contactContainer">
        <div className="contactIntro">
          <h1>Contact</h1>
        </div>


        <div className="contactFormSection">
          <ContactForm />
        </div>

      </div>

    </>
  );
}
